import _ from 'lodash';

const ncArgsMc = (contrato, valor, lista4, valorparaPermRX, numDX) => {
//SI ES NOTA CREDITO => AFECTA LOS MOVIMIENTOS DEL CLIENTE
  let totRecib = valor
  let listColecc = lista4.map(recpago => ({...recpago}))
  listColecc = _.orderBy(listColecc, ['_id'], ['asc'])
  listColecc.forEach((elemento, i) => {
    if(elemento.valorTotal<0){
      totRecib -= elemento.valorTotal
      listColecc[i].valorRecibido = elemento.valorTotal
    }
  })
  listColecc.forEach((elemento, i) => {
    if(elemento.valorTotal>0){
      if(totRecib > elemento.valorTotal - elemento.valorPagado){
        totRecib -= (elemento.valorTotal - elemento.valorPagado)
        listColecc[i].valorRecibido = elemento.valorTotal - elemento.valorPagado
      }else{
        listColecc[i].valorRecibido = totRecib
        totRecib = 0
      }
    }
  })

  let hacerRX = true
  if(numDX===0){
    hacerRX = false
  }
  let actColecc = []
  listColecc.forEach((elemento1, ii) => {
    if(numDX>0&&elemento1.numeroOdeDX>0&&(!elemento1.valorRecibido||elemento1.valorRecibido===0)&&
        elemento1.valorTotal>0){
      hacerRX = false
    }
    if(elemento1.valorRecibido&&elemento1.valorRecibido!==0){
      let valPagado = 0
      if(elemento1.valorPagado){
        valPagado = parseInt(elemento1.valorPagado, 10) + parseInt(elemento1.valorRecibido, 10)
      }else{
        valPagado = parseInt(elemento1.valorRecibido, 10)
      }
      let valParaHacerRX = parseInt(valPagado, 10) + parseInt(valorparaPermRX, 10)
      // console.log("33", numDX, elemento1.numeroOdeDX, valParaHacerRX, valPagado, elemento1.valorTotal)
      // if(numDX>0&&elemento1.numeroOdeDX>0&&valPagado<elemento1.valorTotal&&elemento1.valorTotal>0){
      if(numDX>0&&elemento1.numeroOdeDX>0&&valParaHacerRX<elemento1.valorTotal&&elemento1.valorTotal>0){
        // console.log("33", numDX, elemento1.numeroOdeDX, valParaHacerRX, valPagado, elemento1.valorTotal)
        hacerRX = false
      }

      let argsUpd = {
        "contrato": contrato,
        "_id": elemento1._id,
        "procesado": elemento1.procesado,
        "concepto": elemento1.concepto,
        "numeroFra": elemento1.numeroFra,
        "numeroRC": elemento1.numeroRC,
        "numeroCE": elemento1.numeroCE,
        "numeroOdeDX": elemento1.numeroOdeDX,
        "documento": elemento1.documento,
        "fechaUltPago": elemento1.fechaUltPago,
        "valorUltPago": elemento1.valorUltPago,
        "valorPagado": valPagado,
        "valorPendiente": elemento1.valorTotal - valPagado
      }
      actColecc.push(argsUpd)
    }
  })

  let colecc = {actColecc, hacerRX}

  return colecc
}

export default ncArgsMc
  